<template>
  <section class="information">
    <div v-if="tabsList.length" class="information-tabsName">
      <span
      ><img
        :src="require(`@/assets/dto/dto-information${activeTab + 1}2.png`)"
        alt=""
      ></span>
      <span>{{ tabsList[activeTab][tabsConfigList[1]] }}</span>
    </div>
    <com-tabs
      :list="tabsList"
      class="information-tabs"
      :default-tab="activeTab"
      @change="changeTab"
    >
      <template v-slot:text="{ obj }">
        <div
          :class="{ activeTab: activeTab == obj.key }"
          class="information-tabs-item"
        >
          {{ obj.name }}
        </div>
      </template>
    </com-tabs>
    <div class="information-title">
      政 策 通 知
    </div>
    <div v-loading.fullscreen.lock="loading" class="information-panel">
      <!-- <div v-for="(tabsItem, tabsIndex) in tabsList" :key="tabsIndex"> -->
      <!-- <div v-show="activeTab == tabsIndex"> -->
      <div
        v-for="(item1, index1) in tableData"
        :key="index1"
        class="panel-item"
        @click="handleRouteDto(item1.id)"
      >
        <div class="itemTitle">
          {{ item1.title }}
        </div>
        <span class="item-date">
          发布时间: {{ item1.created_date }}
        </span>
      </div>
      <el-pagination
        class="fun-pagination"
        :current-page="requestParams.page"
        :page-sizes="[15, 20, 30, 50]"
        :page-size="requestParams.page_size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
      <!-- </div> -->
      <!-- </div> -->
    </div>
  </section>
</template>

<script>
import mock from '@/utils/mock'
import comTabs from '@/components/comTabs'
export default {
  components: { comTabs },
  data() {
    return {
      tabsList: [],
      tableData: [],
      requestParams: {
        page: 1,
        page_size: 15
      },
      total: null,
      activeTab: 0,
      loading: false,
      informationInit: mock.notes.information.init
    }
  },
  computed: {
    tabsConfigList() {
      return this.tabsList.length ? Object.keys(this.tabsList[0]) : []
    }
  },
  created() {
    this.loading = true
    // this.initType();
    this.init(this.requestParams)
  },
  mounted() {},
  methods: {
    control(type, condition) {
      return mock.system.global.control[type](condition)
    },
    async initType() {
      this.tabsList = await this.informationInit.types()
      this.requestParams.type = this.tabsList[0].id
      this.init(this.requestParams)
    },
    async init(v) {
      const obj = await this.informationInit.data1(v)
      this.tableData = obj.data
      this.total = obj.total
      this.loading = false
    },
    changeTab(x, y) {
      this.activeTab = x
      this.requestParams.type = y
      this.init(this.requestParams)
    },

    handleSizeChange(val) {
      this.requestParams.page_size = val
      this.init(this.requestParams)
    },
    handleCurrentChange(val) {
      this.requestParams.page = val
      this.init(this.requestParams)
    },
    handleRouteDto(v) {
      this.$router.push({
        path: '/information/details',
        query: {
          id: v
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.fun-pagination {
  @include fun-pagination(32px, right);
  position: absolute;
  right: 20px;
  bottom: 0;
  overflow: hidden;
  background: #fff;
  padding-bottom: 10px;
}
.information {
  display:block;
  background-color: #fff;
  border-radius: 10px;
  margin-top: 50px;
  padding-bottom: 50px;
  height:100%;
  max-height: 800px;
  position: relative;
  overflow: hidden;
  // @include fun-layout();
  width: $xr-min-width;
  &-tabsName {
    margin-top: 58px;
    display: flex;
    > span {
      margin-right: 14px;
      font-family: "AdobeHeitiStd-Regular";
      @include fun-design(1);
      line-height: 30px;
    }
  }
  &-title{
    text-align: center;
    margin-top: 20px;
    color: #333;
    font-size: 26px;
    font-weight: bold;
  }
  &-tabs {
    margin: 0 35px;
    &-item {
      text-align: center;
      @include fun-design(7);
      line-height: 40px;
      width: 60px;
      cursor: pointer;
    }
    .activeTab {
      @include fun-active();
    }
  }
  &-panel {
    margin-top: 46px;
    margin-bottom: 110px;
    margin-left: 27px;
    height: 100%;
    padding-bottom: 200px;
    overflow-y: auto;
    > div {
      > div {
        > div {
          padding-top: 16px;
          height: 90px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          @include fun-border(0,"bottom");
          cursor: pointer;
          &:last-child {
            border: 0;
            > div {
              width: 100%;
              text-align: right;
            }
          }
          > span {
            &:nth-child(1) {
              display: flex;
              align-items: center;
              width: 80%;
              > span {
                &:nth-child(1) {
                  width: 6px;
                  height: 6px;
                  background-color: #a9a9a9;
                  margin-left: 9px;
                }
                &:nth-child(2) {
                  margin-left: 20px;
                  font-family: "AdobeHeitiStd-Regular";
                  width: 80%;
                  @include fun-design(8);
                  @include obj-clamp1();
                }
              }
            }
            &:nth-child(2) {
              flex: 1;
              font-family: "AdobeHeitiStd-Regular";
              font-size: 14px;
              color: #777;
              margin-right: 16px;
              text-align: right;
            }
          }
        }
      }
    }
  }
}

.panel-item{
  line-height: 30px;
  font-size: 16px;
  color: #555;
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 4px;
  border-bottom: 1px solid #eee;
  padding: 6px 0;
  .item-date{
    width: 200px;
    flex-shrink: 0;
    margin-left:25px;
  }
  .itemTitle{
    flex: 1;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;

  }
}
.panel-item:hover{
  color: #2f82ff;
}
</style>
